import { exeRequest } from '../utils/APIUtils'

const toQS = (obj = {}) => {
    const q = Object.entries(obj)
        .filter(([, v]) => v !== undefined && v !== null && v !== '')
        .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
        .join('&');
    return q ? `?${q}` : '';
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    recupererListeVehicules: async () => exeRequest(`/admin/liste-vehicule`, "GET"),
    statsInscriptionsVehicules: async (params = {}) => {
        const { cityCode, from, to } = params;
        return exeRequest(`/admin/stats-inscriptions-vehicules${toQS({ cityCode, from, to })}`, "GET");
    },
    statsClassesServices: async (params = {}) => {
        const { cityCode, from, to } = params;
        return exeRequest(`/admin/stats-classes-services${toQS({ cityCode, from, to })}`, "GET");
    },
    getById: async (id) => exeRequest(`/admin/vehicule/${id}`, "GET"),
    update: async (id, data) => exeRequest(`/admin/vehicule/${id}`, "PUT", data),
    delete: async (id) => exeRequest(`/admin/vehicule/${id}`, "DELETE"),
}